export const slugify = (str) =>
  (str || '').toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '') || 'item';

export const makeUniqueKey = (title, existingKeys) => {
  const base = slugify(title);
  let key = base;
  let n = 2;
  while (existingKeys.includes(key)) {
    key = `${base}-${n}`;
    n += 1;
  }
  return key;
};
